/** @flow */

import React, { Component } from "react";
import Chart from "react-google-charts";
import classNames from "classnames";
import type { ChartWrapperOptions } from "react-google-charts";
import { chartDefaultColors } from "@styles/colors";
import "./horizontal-bar-chart.style.scss";

const pieOptions: ChartWrapperOptions = {
  legend: {
    position: "bottom",
  },
  chartArea: {
    top: 12,
  },
  colors: chartDefaultColors,
};

export type Props = $Exact<{
  options?: Object,
  title?: string,
  fullWidth?: boolean,
  disableBorder?: boolean,
  values: Array<Array<string | number | Object>>,
}>;

export class HorizontalBarChart extends Component<Props> {
  chartWrapper = null;

  onResize = () => {
    this.chartWrapper && this.chartWrapper.draw();
  };
  componentDidMount() {
    window.addEventListener("resize", this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  render() {
    return (
      <div
        className={classNames("item-container chart-block horizontal-bar-chart mt-3 pt-3", {
          "full-width": this.props.fullWidth,
          "disable-border": this.props.disableBorder,
        })}
      >
        {this.props.title ? (
          <div className="chart-title mb-4 text-center">{this.props.title}</div>
        ) : null}
        <Chart
          chartType="BarChart"
          data={this.props.values}
          getChartWrapper={chartWrapper => {
            this.chartWrapper = chartWrapper;
          }}
          options={Object.assign({}, pieOptions, this.props.options)}
        />
      </div>
    );
  }
  static defaultProps = {
    options: {},
  };
}

export default HorizontalBarChart;
